module.exports = __webpack_public_path__ + "media/images/pic/laughing-people-eaea4ff4bac999159a8cdcd2a2068a56.jpeg";